import { frontendURL } from '../../../helper/URLHelper';

import Icerik from './Icerik.vue';
import IcerikGenelBakis from './IcerikGenelBakis.vue';
import IcerikTakvim from './IcerikTakvim.vue';
import IcerikListe from './IcerikListe.vue';
import IcerikOlustur from './IcerikOlustur.vue';
import IcerikMedya from './IcerikMedya.vue';
import IcerikTaslaklar from './IcerikTaslaklar.vue';
import IcerikOnaylar from './IcerikOnaylar.vue';
import IcerikYorumlar from './IcerikYorumlar.vue';
import IcerikIstatistik from './IcerikIstatistik.vue';

// Temsilci de icerik hazirlayabilsin: gonderi yazmak gunluk bir is, her
// seferinde yoneticiyi beklemek isi durdurur. ONAY ve RED yoneticiye kilitli
// ama o kontrol sunucuda ve Onaylar ekraninda; bolumun tamamini temsilciye
// kapatmak, kendi hazirladigi gonderinin ne olduguna bakmasini da engellerdi.
const YETKI = { permissions: ['administrator', 'agent'] };

// Bolum artik HESABA gore bolunmuyor.
//
// Eski tasarimda her sosyal hesap ayri bir alt menuydu ve ayni metin her
// hesap icin bastan yaziliyordu. Kullanicinin isi "Instagram yonetmek" degil:
// olustur -> planla -> yayinla -> sonucunu gor. Bu yuzden alt maddeler artik
// SABIT ve is akisinin adimlarini izliyor; hesap secimi Olustur ekranindaki
// bir alan.
//
// Rota adlari kenar cubugu (Sidebar.vue) ve kabuktaki ust sekmelerle AYNI:
// kullanici hangisinden girerse girsin ayni ekrana duser.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/icerik'),
    component: Icerik,
    meta: YETKI,
    // Bos kabuk yerine dogrudan Genel Bakis'a. Eski surumde buradaki
    // yonlendirme sunucudan gelen ilk hesaba gore yapiliyordu ve eszamansiz
    // olmak zorundaydi; sabit alt maddelerle artik gerekmiyor.
    redirect: () => ({ name: 'icerik_genel_bakis' }),
    children: [
      {
        path: 'genel-bakis',
        name: 'icerik_genel_bakis',
        component: IcerikGenelBakis,
        meta: YETKI,
      },
      {
        path: 'takvim',
        name: 'icerik_takvim',
        component: IcerikTakvim,
        meta: YETKI,
      },
      {
        path: 'icerikler',
        name: 'icerik_liste',
        component: IcerikListe,
        meta: YETKI,
      },
      {
        path: 'olustur',
        name: 'icerik_olustur',
        component: IcerikOlustur,
        meta: YETKI,
      },
      {
        path: 'medya',
        name: 'icerik_medya',
        component: IcerikMedya,
        meta: YETKI,
      },
      {
        path: 'taslaklar',
        name: 'icerik_taslaklar',
        component: IcerikTaslaklar,
        meta: YETKI,
      },
      {
        path: 'yorumlar',
        name: 'icerik_yorumlar',
        component: IcerikYorumlar,
        meta: YETKI,
      },
      {
        path: 'istatistik',
        name: 'icerik_istatistik',
        component: IcerikIstatistik,
        meta: YETKI,
      },
      {
        path: 'onaylar',
        name: 'icerik_onaylar',
        component: IcerikOnaylar,
        meta: YETKI,
      },
    ],
  },
];
